import $ from 'jquery';
import { smoothscroll } from '../utils/smoothscroll';
import { debounce } from '../utils/functions';

const $window = $(window);
const $body = $('body');
const $header = $('.header');
const $hamburger = $('.header__hamburger');
const $search = $('.search');
const $searchTrigger = $('.search__trigger');
const $searchClose = $('.search__close');
const $searchContainer = $('.search__container');
const $searchInput = $('.search__input');
const $searchSubmit = $('.search__submit');
const $searchContent = $('.search__content');
const $navMenuTitle = $('.navigation-menu__title');

$(function () {
    const filter = {
        page: 1,
        search: $searchInput.val(),
        lang: $search.data('lang'),
    };

    $window.on(
        'resize:width',
        debounce(function () {
            hideSearch(filter);
        }, true)
    );
    $searchTrigger.on('click', function (event) {
        event.stopPropagation();
        toggleSearch(filter);
    });
    $searchContainer.on('click', function (event) {
        event.stopPropagation();
    });
    $body.on('click', function () {
        hideSearch(filter);
    });
    $hamburger.on('click', function () {
        hideSearch(filter, true);
    });
    $searchClose.on('click', function () {
        hideSearch(filter, true);
    });
    $navMenuTitle.on('click', function () {
        hideSearch(filter, true);
    });
    $search.on('keydown', function (e) {
        if ($search.hasClass('active')) {
            if (e.key === 'Tab') {
                e.preventDefault();
            } else if (e.key === 'Escape') {
                hideSearch(filter, true);
            }
        }
    });
    bindSearch(filter);
});

const toggleSearch = (filter) => {
    if ($search.hasClass('active')) {
        hideSearch(filter, true);
    } else {
        showSearch();
    }
};

const showSearch = () => {
    $search.addClass('active');
    $searchTrigger.addClass('active');
    $searchInput.val('');
    $searchInput.trigger('focus');
    $header.addClass('header--search-active');
    $search.attr('aria-hidden', 'false');
};

const hideSearch = (filter, force = false) => {
    if ($search.hasClass('active')) {
        if (force === true) {
            $searchInput.val('');
        }
        if (!$searchInput.val()) {
            filter.page = 1;
            filter.search = $searchInput.val();
            reRenderSearch(filter);
            $search.removeClass('active');
            $searchTrigger.removeClass('active');
            $searchTrigger.trigger('focus');
            $header.removeClass('header--search-active');
            $search.attr('aria-hidden', 'true');
        }
    }
};

const bindPagination = (filter) => {
    $searchContent.off('click', '.pagination__item');
    $searchContent.on('click', '.pagination__item', function () {
        filter.page = $(this).data('page');
        reRenderSearch(filter, true);
    });
};

const bindSearch = (filter) => {
    $searchInput.on(
        'input',
        debounce(function () {
            filter.search = $searchInput.val();
            reRenderSearch(filter);
        })
    );
};

const reRenderSearch = async (filter, scrollTop = false) => {
    if (filter.search === '') {
        filter.page = 1;
        $searchContent.html('');
    } else {
        const data = await getSearchItems(filter);
        $searchContent.html(data.html);
        bindPagination(filter);

        if (scrollTop === true) {
            smoothscroll(0, 0, 500, $search);
        }
    }
};

const getSearchItems = async (filter) => {
    try {
        const response = await fetch(SITE_PARAMS.site_url + '/wp-json/nitra/v1/search/html', {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(filter),
        });
        const result = await response.json();
        return result;
    } catch (e) {
        console.log(e);
        return null;
    }
};

// search behaviour

$searchInput.on('keydown', function (event) {
    if (event.shiftKey && event.key === 'Tab') {
        event.preventDefault();
        $search.removeClass('active');
        $searchTrigger.removeClass('active');
        $searchTrigger.trigger('focus');
        $header.removeClass('header--search-active');
    } else if (event.key === 'Tab') {
        const $searchItems = $('ul.search__items');
        const $searchItem = $searchItems.find('li.search-item');
        if ($searchItems.length === 0) {
            $searchSubmit.trigger('focus');
        } else {
            $searchItems.trigger('focus');
            $searchItem.first().trigger('focus');
        }
    }
});

$searchContent.on('keydown', 'li.search-item', function (event) {
    const $this = $(this);
    if (event.shiftKey && event.key === 'Tab') {
        if ($this.is(':first-child')) {
            $searchSubmit.trigger('focus');
        } else if ($this.not(':first-child')) {
            $this.prev().focus();
        }
    } else if (event.key === 'Tab') {
        if ($this.is(':last-child')) {
            const $paginationItems = $('.pagination');
            const $paginationItemActive = $('button.pagination__item.pagination__item_active');
            if ($paginationItems === 0) {
                $searchSubmit.trigger('focus');
            } else {
                $paginationItems.trigger('focus');
                $paginationItemActive.trigger('focus');
            }
        } else if ($this.not(':last-child')) {
            $this.next().focus();
        }
    }
});
$searchContent.on('keydown', 'button.pagination__item', function (event) {
    const $searchItems = $('ul.search__items');
    const $searchItem = $searchItems.find('li.search-item');
    const $this = $(this);
    if (event.shiftKey && event.key === 'Tab') {
        if ($this.is(':first-child')) {
            $searchItem.last().trigger('focus');
        } else if (
            $this.not(':first-child') &&
            $this.prev().is(':disabled') &&
            $this.prev().is(':first-child')
        ) {
            $searchItem.last().trigger('focus');
        } else if ($this.not(':first-child') && $this.prev().is(':disabled')) {
            $this.prev().prev().focus();
        } else if ($this.not(':first-child')) {
            $this.prev().focus();
        }
    } else if (event.key === 'Tab') {
        if ($this.is(':last-child')) {
            $searchSubmit.trigger('focus');
        } else if (
            $this.not(':last-child') &&
            $this.next().is(':disabled') &&
            $this.next().is(':last-child')
        ) {
            $searchSubmit.trigger('focus');
        } else if ($this.not(':last-child') && $this.next().is(':disabled')) {
            $this.next().next().focus();
        } else if ($this.not(':last-child')) {
            $this.next().focus();
        }
    }
});

$searchInput.on('keydown', function (event) {});

$searchSubmit.on('keydown', function (event) {
    if (event.shiftKey && event.key === 'Tab') {
        event.preventDefault();
        $searchInput.trigger('focus');
    } else if (event.key === 'Tab') {
        event.preventDefault();
        $searchClose.trigger('focus');
    }
});

$searchClose.on('keydown', function (event) {
    if (event.shiftKey && event.key === 'Tab') {
        $searchSubmit.trigger('focus');
    } else if (event.key === 'Tab') {
        $searchInput.trigger('focus');
    }
    if (event.key === 'Enter') {
        event.preventDefault();
        $search.removeClass('active');
        $searchTrigger.removeClass('active');
        $searchTrigger.trigger('focus');
        $header.removeClass('header--search-active');
    }
});
